module.exports = __webpack_public_path__ + "img/generateNmbr.8cb9fd86.png";